function EventUtil () {
}

EventUtil.onEvent = function (target, type, listener) {

    if (target.addEventListener != null) {

        target.addEventListener(type, listener);

    } else if (target.attachEvent != null) {

        target.attachEvent("on" + type, listener);
    }
};

EventUtil.offEvent = function (target, type, listener) {

    if (target.removeEventListener != null) {

        target.removeEventListener(type, listener);

    } else if (target.detachEvent != null) {

        target.detachEvent("on" + type, listener);
    }
};

// jQuery ready callback ($(callback)) waits until document DOMContentLoaded, document readyState complete or window load events are fired
// Due to PwM design, injection may be executed after DOMContentLoaded, thus the callback have to wait until all contents are fully loaded.
// Therefore, we put document readyState interative into consideration
EventUtil.onDocReady = function (callback) {

    function isDocumentReady() {

        var readyState = window.document.readyState;
        return (readyState === "interactive" || readyState === "complete");
    }

    function readyStateChangeCallback() {

        if (isDocumentReady() === true) {

            detach();
            callback();
        }
    }
    
    function detach() {

        EventUtil.offEvent(document, "readystatechange", readyStateChangeCallback);
    }

    function attach() {

        EventUtil.onEvent(document, "readystatechange", readyStateChangeCallback);
    }

    if (isDocumentReady() === true) {

        callback();

    } else {

        attach();
    }
};

module.exports = EventUtil;